export const durationOptions: ComponentFramework.PropertyHelper.OptionMetadata[] = [
    { Label: '1', Value: 1, Color: '' },
    { Label: '15', Value: 2, Color: '' },
    { Label: '30', Value: 3, Color: '' },
    { Label: '45', Value: 4, Color: '' },
    { Label: '60', Value: 5, Color: '' },
    { Label: '90', Value: 6, Color: '' },
    { Label: '120', Value: 7, Color: '' },
    { Label: '150', Value: 8, Color: '' },
    { Label: '180', Value: 9, Color: '' },
    { Label: '210', Value: 10, Color: '' },
    { Label: '240', Value: 11, Color: '' },
    { Label: '270', Value: 12, Color: '' },
    { Label: '300', Value: 13, Color: '' },
    { Label: '330', Value: 14, Color: '' },
    { Label: '360', Value: 15, Color: '' },
    { Label: '390', Value: 16, Color: '' },
    { Label: '420', Value: 17, Color: '' },
    { Label: '450', Value: 18, Color: '' },
    { Label: '480', Value: 19, Color: '' },
    { Label: '1440', Value: 20, Color: '' },
    { Label: '2880', Value: 21, Color: '' },
    { Label: '4320', Value: 22, Color: '' },
];